module.exports = __webpack_public_path__ + "static/media/067.abf16ae6.jpg";